import { useMemo } from 'react'

import Box from '@ilg-totallymoney/ui/components/Box'
import LinkButton from '@ilg-totallymoney/ui/components/LinkButton'
import { ButtonStyleProps } from '@ilg-totallymoney/ui/styles/button'

import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

import useAppQueryState from '@hooks/useAppQueryState'
import useLogEvents from '@hooks/useLogEvents'

import { getCategoryPathForId } from '@utils/getCategoryPathForId'
import { getRedirectAccountUrl } from '@utils/getRedirectAccountUrl'

const UnscoredButton = ({
    maxWidth,
    text = 'Find a card',
    variant = 'primary',
}: {
    maxWidth?: string
    text?: string
    variant?: ButtonStyleProps['variant']
}) => {
    const { appQueryState } = useAppQueryState()
    const { logUnscoredPagesFormOpenEvent } = useLogEvents()

    const formUrl = useMemo(() => {
        const urlCategoryPath =
            appQueryState.categoryId == CreditCardProductCategory.BestCards
                ? ''
                : getCategoryPathForId(appQueryState.categoryId!)

        const data = urlCategoryPath
            ? { queryObject: { category: urlCategoryPath } }
            : {}

        return getRedirectAccountUrl(data)
    }, [appQueryState.categoryId])

    const handleClick = () => {
        logUnscoredPagesFormOpenEvent()

        window.location.href = formUrl
    }

    return (
        <Box width={['100%', '280px']} maxWidth={maxWidth ?? 'unset'}>
            <LinkButton
                href={formUrl}
                variant={variant}
                text={text}
                onClick={handleClick}
            />
        </Box>
    )
}

export default UnscoredButton
